<template>
  <v-container fluid class="px-0 py-0">
    <v-main>
      <v-row class="px-0 pt-12">
        <v-col>
          <h1 class="center--text gm-darkblue--text">Contact us</h1>
        </v-col>
      </v-row>

      <v-row>
        <v-col>
          <div class="highlight-img"></div>
        </v-col>
      </v-row>

      <!-- Desktop Footer -->
      <v-row justify="center" class="d-none d-md-flex my-0 gm-darkblue desktop-footer">
        <v-col cols="4">
          <v-card class="gm-darkblue">
            <v-card-title class="gm-yellow--text">Address</v-card-title>
            <v-card-text class="gm-whitish--text">#1 Onu street, off Eneka road, Port Harcourt, Rivers state.</v-card-text>

            <v-card-title class="gm-yellow--text">Email</v-card-title>
            <v-card-text class="gm-whitish--text">greenmasterslimited@gmail.com</v-card-text>

            <v-card-title class="gm-yellow--text">Phone</v-card-title>
            <v-card-text class="gm-whitish--text">+234 814 567 8910</v-card-text>

            <v-card-title class="gm-yellow--text">Business Hours</v-card-title>
            <v-card-text class="gm-whitish--text">7am to 4pm <br /> Mon to Fri</v-card-text>
          </v-card>
        </v-col>
        <v-col cols="4">
          <v-card class="gm-darkblue">
            <v-card-title class="gm-yellow--text">Quick Links</v-card-title>
            <v-card-text>
              <router-link to='/' class="gm-whitish--text">Home</router-link>
            </v-card-text>
            <v-card-text>
              <router-link to='/services' class="gm-whitish--text">Services</router-link>
            </v-card-text>
            <v-card-text>
              <router-link to='/about' class="gm-whitish--text">About</router-link>
            </v-card-text>
            <v-card-text>
              <router-link to='/projects' class="gm-whitish--text">Projects</router-link>
            </v-card-text>
            <v-card-text>
              <router-link to='/policy' class="gm-whitish--text">Policy</router-link>
            </v-card-text>
          </v-card>
        </v-col>
        <v-col cols="4">
          <v-card class="gm-darkblue">
            <v-card-title class="gm-yellow--text">Map</v-card-title>
            <div class="map">
              <div class="mapouter">
                <div class="gmap_canvas">
                  <iframe id="gmap_canvas" src="https://maps.google.com/maps?q=1%20Onu%20street,%20Eneka%20Rd%20Port%20Harcourt&t=&z=13&ie=UTF8&iwloc=&output=embed" frameborder="0" scrolling="no" marginheight="0" marginwidth="0"></iframe>
                  <a href="https://123movies-to.org"></a>
                  <br>
                  <a href="https://www.embedgooglemap.net">google map websites</a>
                </div>
              </div>
            </div>
          </v-card>
        </v-col>

        <v-row justify="center">
          <v-col>
            <h4 class="gm-whitish--text center--text py-12">&copy; Copyright Greenmasters Limited 2021</h4>
          </v-col>
        </v-row>
      </v-row>

      <!-- Tablet Footer -->
      <v-row justify="center" class="d-none d-sm-flex d-md-none my-0 gm-darkblue tablet-footer">
        <v-col cols="6" class="px-6">
          <v-card class="gm-darkblue">
            <v-card-title class="gm-yellow--text">Address</v-card-title>
            <v-card-text class="gm-whitish--text">#1 Onu street, off Eneka road, Port Harcourt, Rivers state.</v-card-text>

            <v-card-title class="gm-yellow--text">Email</v-card-title>
            <v-card-text class="gm-whitish--text">greenmasterslimited@gmail.com</v-card-text>

            <v-card-title class="gm-yellow--text">Phone</v-card-title>
            <v-card-text class="gm-whitish--text">+234 814 567 8910</v-card-text>

            <v-card-title class="gm-yellow--text">Business Hours</v-card-title>
            <v-card-text class="gm-whitish--text">7am to 4pm <br /> Mon to Fri</v-card-text>
          </v-card>
        </v-col>

        <v-col cols="6" class="px-6">
          <v-card class="gm-darkblue">
            <v-card-title class="gm-yellow--text center--text">Quick Links</v-card-title>
            <v-card-text>
              <router-link to='/' class="gm-whitish--text">Home</router-link>
            </v-card-text>
            <v-card-text>
              <router-link to='/services' class="gm-whitish--text">Services</router-link>
            </v-card-text>
            <v-card-text>
              <router-link to='/about' class="gm-whitish--text">About</router-link>
            </v-card-text>
            <v-card-text>
              <router-link to='/projects' class="gm-whitish--text">Projects</router-link>
            </v-card-text>
            <v-card-text>
              <router-link to='/policy' class="gm-whitish--text">Policy</router-link>
            </v-card-text>
          </v-card>
        </v-col>

        <v-col cols="12">
          <v-card class="gm-darkblue">
            <v-card-title class="gm-yellow--text center--text">Map</v-card-title>
            <div class="map">
              <div class="mapouter">
                <div class="gmap_canvas">
                  <iframe id="gmap_canvas" src="https://maps.google.com/maps?q=1%20Onu%20street,%20Eneka%20Rd%20Port%20Harcourt&t=&z=13&ie=UTF8&iwloc=&output=embed" frameborder="0" scrolling="no" marginheight="0" marginwidth="0"></iframe>
                  <a href="https://123movies-to.org"></a>
                  <br>
                  <a href="https://www.embedgooglemap.net">google map websites</a>
                </div>
              </div>
            </div>
          </v-card>
        </v-col>

        <v-row justify="center">
          <v-col>
            <h4 class="gm-whitish--text center--text py-12">&copy; Copyright Greenmasters Limited 2021</h4>
          </v-col>
        </v-row>
      </v-row>

      <!-- Mobile Footer -->
      <v-row justify="center" class="d-flex d-sm-none my-0 gm-darkblue mobile-footer">
        <v-col cols="12" class="px-6">
          <v-card class="gm-darkblue">
            <v-card-title class="gm-yellow--text">Address</v-card-title>
            <v-card-text class="gm-whitish--text">#1 Onu street, off Eneka road, Port Harcourt, Rivers state.</v-card-text>

            <v-card-title class="gm-yellow--text">Email</v-card-title>
            <v-card-text class="gm-whitish--text">greenmasterslimited@gmail.com</v-card-text>

            <v-card-title class="gm-yellow--text">Phone</v-card-title>
            <v-card-text class="gm-whitish--text">+234 814 567 8910</v-card-text>

            <v-card-title class="gm-yellow--text">Business Hours</v-card-title>
            <v-card-text class="gm-whitish--text">7am to 4pm <br /> Mon to Fri</v-card-text>
          </v-card>
        </v-col>
        <v-col cols="12" class="px-6">
          <v-card class="gm-darkblue">
            <v-card-title class="gm-yellow--text">Quick Links</v-card-title>
            <v-card-text>
              <router-link to='/' class="gm-whitish--text">Home</router-link>
            </v-card-text>
            <v-card-text>
              <router-link to='/services' class="gm-whitish--text">Services</router-link>
            </v-card-text>
            <v-card-text>
              <router-link to='/about' class="gm-whitish--text">About</router-link>
            </v-card-text>
            <v-card-text>
              <router-link to='/projects' class="gm-whitish--text">Projects</router-link>
            </v-card-text>
            <v-card-text>
              <router-link to='/policy' class="gm-whitish--text">Policy</router-link>
            </v-card-text>
          </v-card>
        </v-col>

        <v-col cols="12">
          <v-card class="gm-darkblue">
            <v-card-title class="gm-yellow--text">Map</v-card-title>
            <div class="map">
              <div class="mapouter">
                <div class="gmap_canvas">
                  <iframe id="gmap_canvas" src="https://maps.google.com/maps?q=1%20Onu%20street,%20Eneka%20Rd%20Port%20Harcourt&t=&z=13&ie=UTF8&iwloc=&output=embed" frameborder="0" scrolling="no" marginheight="0" marginwidth="0"></iframe>
                  <a href="https://123movies-to.org"></a>
                  <br>
                  <a href="https://www.embedgooglemap.net">google map websites</a>
                </div>
              </div>
            </div>
          </v-card>
        </v-col>

        <v-row justify="center">
          <v-col>
            <h4 class="gm-whitish--text center--text py-12">&copy; Copyright Greenmasters Limited 2021</h4>
          </v-col>
        </v-row>
      </v-row>
    </v-main>
  </v-container>
</template>

<script>
export default {
  name: 'contact-highlight'
}
</script>

<style scoped>
.highlight-img {
  width: 100vw;
  height: 60vh;
  background-image: linear-gradient(to right, rgb(0,0,0,0.5), rgb(0,0,0,0.5)), url('../assets/images/contact/contact.jpeg');
  background-attachment: fixed;
  background-position: 50% 0%;
  background-size: cover;
  background-repeat: no-repeat;
}

.highlight-img:before {
  height: 100%;
  content: '';
  display: block;
  position: relative;
  top: -5px;
  clip-path: polygon(0%0%, 80%0%, 0%50%, 0%0%);
  background: white;
}

.highlight-img:after {
  height: 100%;
  content: '';
  display: block;
  position: relative;
  top: -99%;
  clip-path: polygon(100%100%, 20%100%, 100%50%, 100%100%);
  background: var(--gm-darkblue);
}

.desktop-footer .mapouter {
  position:relative;
  text-align:right;
  height:60vh;
  width:100%;
}

.desktop-footer .gmap_canvas {
  overflow:hidden;
  background:none!important;
  height:60vh;
  width:100%;
}

.desktop-footer #gmap_canvas {
  height:60vh;
  width: 100%;
}

.tablet-footer .mapouter {
  position:relative;
  text-align:right;
  height:60vh;
  width:100%;
}

.tablet-footer .gmap_canvas {
  overflow:hidden;
  background:none!important;
  height:60vh;
  width:100%;
}

.tablet-footer #gmap_canvas {
  height:60vh;
  width: 100%;
}

.mobile-footer .mapouter {
  position:relative;
  text-align:right;
  height:50vh;
  width:100%;
}

.mobile-footer .gmap_canvas {
  overflow:hidden;
  background:none!important;
  height:50vh;
  width:100%;
}

.mobile-footer #gmap_canvas {
  height:50vh;
  width: 100%;
}
</style>
